var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    viewBox: "0 0 37 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface30041726"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EthIconTop",
    gradientUnits: "userSpaceOnUse",
    x1: 489.0089,
    y1: -621.0831,
    x2: 550.9689,
    y2: -728.401,
    gradientTransform: "matrix(0.3721 0 0 -0.3721 -174.7877 -220.4829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A200FA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EthIconTop)",
    d: "M2.6,32.2l15,8.6c0.3,0.2,0.6,0.3,1,0.3s0.7-0.1,1-0.3l15-8.6c0.5-0.3,0.8-0.7,0.9-1.3 s0-1.1-0.3-1.6l-15-23.6c-0.4-0.6-1-0.9-1.7-0.9s-1.3,0.3-1.7,0.9l-15,23.6c-0.3,0.5-0.4,1-0.3,1.6C1.8,31.5,2.1,31.9,2.6,32.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EthIconBottom",
    gradientUnits: "userSpaceOnUse",
    x1: 456.2825,
    y1: -578.4278,
    x2: 543.0568,
    y2: -728.7253,
    gradientTransform: "matrix(0.3721 0 0 -0.3721 -174.7877 -220.4829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A200FA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EthIconBottom)",
    d: "M36.8,35c-0.3-0.4-0.8-0.4-1.3-0.2L18.6,44.9L1.7,34.8c-0.4-0.2-0.9-0.2-1.3,0.2 c-0.3,0.4-0.3,0.9-0.1,1.3L17,58.5c0.4,0.5,1,0.8,1.6,0.8s1.2-0.3,1.6-0.8l16.6-22.2C37.2,35.9,37.1,35.4,36.8,35z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth_icon.e960ace1.svg";
export { ForwardRef as ReactComponent };